import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';

export default Vue.use(VueAxios, axios);
